import { authRoutes } from '~/utils/routes/auth';
import { routesPublic } from '~/utils/routes/public';

export const publicRoutes = [...routesPublic, ...authRoutes];
